import { FilterOverviewType } from 'components/BusinessActivity/types';
import { TranslateFn } from 'i18n';

const getLocationOverview = (
  t: TranslateFn,
  result: FilterOverviewType,
  state: any,
  tKey: 'invoices' | 'packages' | 'performance' | 'transactions' | 'archive',
): FilterOverviewType | undefined => {
  const nsKey = tKey === 'archive' ? 'remittance_sheet' : 'business_activity';

  result.helpText = t(`${nsKey}_${tKey}.filter.location.locationField.label`, 'Location');
  const locations = Array.isArray(state) ? state?.length : 1;

  if (locations > 1) {
    result.label = t(`${nsKey}_${tKey}.filter.location.selectedMultiple`, 'Selected (%number%)', {
      number: state.length,
    });
    return result;
  } else if (locations === 1) {
    result.label = state.toString();
    return result;
  }
  return undefined;
};

export default getLocationOverview;
